export const __federation__ = "__federation__"
export const onLoadKey = "onLoad"
export const moduleInstanceKey = "moduleInstance"

export const defineDynamicImport = (globalName: string, module: any) => {
    // @ts-ignore
    if (window[__federation__] && window[__federation__][globalName] && window[__federation__][globalName][onLoadKey]) {
        // @ts-ignore
        window[__federation__][globalName][onLoadKey]({[globalName]: module})
    } else {
        //console.log('__federation__ loader not defined for module', module);
    }
}